import { gql } from '@apollo/client';

export const deleteActivity = gql`
  mutation deleteActivity($id: ObjectId!) {
    deleteActivity(id: $id)
  }
`;
export const DuplicateEpisode = gql`
mutation DuplicateEpisode($episodeId: ObjectId!) {
  duplicateEpisode(episodeId: $episodeId) {
    _id
  }
}`;

export const DuplicateRoad = gql`
mutation DuplicateRoad($roadId: ObjectId!) {
  duplicateRoad(roadId: $roadId) {
    _id
  }
}`;

export const DuplicateActivity = gql`
mutation DuplicateActivity($activityId: ObjectId!) {
  duplicateActivity(activityId: $activityId) {
    _id
  }
}`;

export const CreateActivity = gql`
  mutation CreateActivity($createActivityInput: CreateActivityInput!) {
    createActivity(createActivityInput: $createActivityInput)
  }
`;

export const UpdateActivity = gql`
  mutation updateActivity($updateActivityInput: UpdateActivityInput!) {
    updateActivity(updateActivityInput: $updateActivityInput)
  }
`;

export const GetActivityById = gql`
  mutation GetActivityById($activityId: ObjectId!) {
    getActivityById(activityId: $activityId) {
      _id
      name
      description
      friends
      form {
        type
        question
        answers
      }
      list
      cover
      audio
      status
      type
      video
    }
  }
`;

// ** Episodes

export const GetEpisodeById = gql`
  mutation GetEpisodeById($episodeId: ObjectId!) {
    getEpisodeById(episodeId: $episodeId) {
      _id
      title
      description
      frases
      contents {
        content
        type
      }
      pillars {
        emotions
        relations
        transformation
        selfEsteem
        purpose
      }
      tags
      cover
      status
      activity
      gender
    }
  }
`;

export const DeleteEpisode = gql`
  mutation deleteEpisode($episodeId: ObjectId!) {
    deleteEpisode(episodeId: $episodeId)
  }
`;

export const CreateEpisode = gql`
  mutation CreateEpisode($createEpisodeInput: CreateEpisodeInput!) {
    createEpisode(createEpisodeInput: $createEpisodeInput)
  }
`;

export const UpdateEpisode = gql`
  mutation UpdateEpisode($updateEpisodeInput: UpdateEpisodeInput!) {
    updateEpisode(updateEpisodeInput: $updateEpisodeInput)
  }
`;

// ** Roads

export const GetRoadById = gql`
  mutation GetRoadById($roadId: ObjectId!) {
    getRoadById(roadId: $roadId) {
      _id
      description
      membership
      episodes
      cover
      rate
      status
      new
      disable
      started
      finished
      name
      challenge
      gender
    }
  }
`;

export const GetRoadDetailsById = gql`
  query GetRoadDetailsById($id: ObjectId!) {
    getRoadDetailsById(id: $id) {
      _id
      description
      membership
      episodes {
        _id
        title
        cover
        activity
      }
      pillars {
        emotions
        purpose
        relations
        selfEsteem
        transformation
      }
      cover
      rate
      status
      new
      disable
      started
      finished
      name
      likes
      createdAt
      gender
    }
  }
`;

export const DeleteRoad = gql`
  mutation DeleteRoad($roadId: ObjectId!) {
    deleteRoad(roadId: $roadId)
  }
`;

export const CreateRoad = gql`
  mutation CreateRoad($createRoadInput: CreateRoadInput!) {
    createRoad(createRoadInput: $createRoadInput)
  }
`;

export const UpdateRoad = gql`
  mutation UpdateRoad($updateRoadInput: UpdateRoadInput!) {
    updateRoad(updateRoadInput: $updateRoadInput)
  }
`;

export const GetRankingRoadsList = gql`
  mutation getRankingRoads($input: SearchRoadsFiltersInput!) {
    getRankingRoads(input: $input) {
      docs {
        _id
        name
        description
        membership
        cover
        status
        new
        started
        finished
        episodes
        likes
      }
      limit
      page
      totalPillars {
        emotions
        purpose
        relations
        selfEsteem
        transformation
      }
      totalDocs
      totalPages
    }
  }
`;

export const GET_ROAD_HISTORY = gql`
  query ListRoadsHistoryAdminFinished(
    $id: ObjectId!
    $input: SearchRoadsHistoryInput!
  ) {
    listRoadsHistoryAdminFinished(id: $id, input: $input) {
      docs {
        _id
        reminder
        createdAt
        finishedAt
        road {
          _id
          name
          cover
        }
        currentEpisode
        completed
        rate
        comment
        user {
          _id
          fullName
        }
      }
      page
      limit
      totalDocs
      totalPages
    }
  }
`;

export const listUsersByActivity = gql`
  query ListUsersByActivity($input: UsersActivityInput!) {
    listUsersByActivity(input: $input) {
      _id
      road
      _id
      road
      createdAt
      finishedAt
      leadForm {
        id
        form {
          type
          question
          answers
        }
        response
      }
      leadAudio {
        audio
        cover
      }
      leadVideo
      leadFriends {
        fullName
        email
        status
        response
      }
      reminder
      type
      completed
      leadList
      user {
        _id
        fullName
        email
        phone
        phonecode
      }
    }
  }
`;
